// Account's own header, as Account.dc.html draws it: the wordmark and a Library link, with the
// member's initials in the gold ring. No search and no bell on this page. At phone width the same 3
// things sit in PhoneLibrary.dc.html's 60px header (no board draws Account on a phone).
import { Link } from '../lib/router.jsx'
import { Wordmark } from '../shell/Marks.jsx'

export function AccountHeader({ initials, phone }) {
  return (
    <header className={phone ? 'ac-header ac-header--phone' : 'ac-header'}>
      <Wordmark className={phone ? 'mark mark--phone' : 'mark mark--header'} />
      <div className="ac-header-right">
        <Link to="/" className="ac-header-link">Library</Link>
        <span className="ac-initials" aria-hidden="true">{initials}</span>
      </div>
    </header>
  )
}
